import SpinwheelUnableToFindCreditReport from '../../../../onboarding/components/spinwheel/SpinwheelUnableToFindCreditReport';

export default function SpinwheelUnableToFindCreditReportScreen() {
    return <SpinwheelUnableToFindCreditReport />;
}
